import BaseModel from './BaseModel';

class Addon extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.addon_type = data.addon_type || "";
    this.price = data.price || "";
    this.swap_count_validity = data.swap_count_validity || "";
    this.time_validity = data.time_validity || "";
    this.description = data.description || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      addon: {
        name: this.name,
        addon_type: this.addon_type,
        price: this.price === "" ? 0 : this.price,
        swap_count_validity: this.swap_count_validity,
        time_validity: this.time_validity,
        description: this.description,
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if(this[field] === "") {
          this.errors.name = "Name cannot be blank.";
        } else {
          delete this.errors.name;
        }
      },
      addon_type: () => {
        if(this[field] === "") {
          this.errors.addon_type = "Please Select Addon Type.";
        } else {
          delete this.errors.addon_type;
        }
      },
      swap_count_validity: () => {
        if(this[field] === "") {
          this.errors.swap_count_validity = "This field is required.";
        } else {
          delete this.errors.swap_count_validity;
        }
      },
      time_validity: () => {
        if(this[field] === "") {
          this.errors.time_validity = "This field is required.";
        } else {
          delete this.errors.time_validity;
        }
      },
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }

}

export default Addon;
